import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, ChevronDown, Check } from "lucide-react";
import { useShop, COUNTRIES } from "@/context/ShopContext";

export default function RegionBar() {
  const { region, chooseRegion, cartCount } = useShop();
  const [open, setOpen] = useState(false);
  return (
    <div className="sticky top-0 z-40 bg-[#14241C] text-white" data-testid="region-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-12 flex items-center justify-between text-sm">
        <div className="relative">
          <button onClick={() => setOpen(!open)} data-testid="region-toggle" className="inline-flex items-center gap-2 hover:text-[#E0A526] transition-colors">
            <span className="text-white/60">Shopping from:</span>
            <span className="font-semibold">{region.flag} {region.name}</span>
            <ChevronDown size={15} className={open ? "rotate-180 transition-transform" : "transition-transform"} />
          </button>
          {open && (
            <div className="absolute left-0 mt-2 w-56 bg-white text-[#14241C] rounded-xl shadow-2xl overflow-hidden py-1" data-testid="region-menu">
              {COUNTRIES.map((c) => (
                <button key={c.code} onClick={() => { chooseRegion(c); setOpen(false); }} data-testid={`region-opt-${c.code}`}
                  className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-[#FBF0E2] text-left">
                  <span>{c.flag} {c.name}</span>
                  {region.code === c.code && <Check size={15} className="text-[#1F4D2E]" />}
                </button>
              ))}
            </div>
          )}
        </div>
        <Link to="/cart" data-testid="cart-link" className="inline-flex items-center gap-2 hover:text-[#E0A526] transition-colors">
          <ShoppingBag size={17} /> Cart{cartCount > 0 && <span className="bg-[#E0A526] text-[#14241C] rounded-full px-2 py-0.5 text-xs font-bold">{cartCount}</span>}
        </Link>
      </div>
    </div>
  );
}
